import { toast } from 'react-toastify';
import { mySip, dashboard } from '../../services/apiVariable';
import { apiCall } from '../../services/api';

export const getAllocatedCampaigns = (id, page = 1, limit = null, subId) => new Promise((resolve, reject) => {
  mySip.getAllocatedFundraisers.userId = id;
  mySip.getAllocatedFundraisers.page = page;
  mySip.getAllocatedFundraisers.limit = limit;
  mySip.getAllocatedFundraisers.subId = subId;
    
  apiCall({ ...mySip.getAllocatedFundraisers })
    .then((res) => {
      resolve(res);
      if (res.status === 200) {
        resolve(res);
      }
    })
    .catch((err) => {
      // console.log(err);
      reject(err);
    });
});

export const editProfile = (id, body) => new Promise((resolve, reject) => {
  dashboard.editProfile.entityId = id;
    
  apiCall({ ...dashboard.editProfile, body })
    .then((res) => {
      if (res.status === 200) {
        resolve(res);
      }
    })
    .catch((err) => {
      // console.log(err);
      reject(err);
    });
});

export const editProfilePic = (id, body) => new Promise((resolve, reject) => {
  dashboard.editProfilePic.entityId = id;
    
  apiCall({ ...dashboard.editProfilePic, body })
    .then((res) => {
      if (res.status === 200) {
        resolve(res);
        toast.success('Profile picture updated', { theme: 'colored', autoClose: 3000, position: 'top-right' });
      }
    })
    .catch((err) => {
      // console.log(err);
      reject(err);
    });
});

export const pledgeMoreSipSubscription = (id, body) => new Promise((resolve, reject) => {
  mySip.pledgeMoreSipSubscription.subsId = id;

  apiCall({ ...mySip.pledgeMoreSipSubscription, body })
    .then((res) => {
      if (res.status === 200) {
        resolve(res);
      }
    })
    .catch((err) => {
      // console.log(err);
      reject(err);
    });
});

export const cancelSipSubscription = (id, reasons) => new Promise((resolve, reject) => {
  mySip.cancelSipSubscription.subsId = id;
  mySip.cancelSipSubscription.reasons = reasons;

  apiCall({ ...mySip.cancelSipSubscription })
    .then((res) => {
      if (res.status === 200) {
        resolve(res);
      }
    })
    .catch((err) => {
      // console.log(err);
      reject(err);
    });
});

export const setnotificationPreference = (id, body) => new Promise((resolve, reject) => {
  mySip.notificationPreference.entityId = id;
      
  apiCall({ ...mySip.notificationPreference, body })
    .then((res) => {
      resolve(res);
      if (res.status === 200) {
        resolve(res);
      }
    })
    .catch((err) => {
      console.log(err);
      reject(err);
    });
});

export const getConfirmOTP = (body) => new Promise((resolve, reject) => {
  apiCall({ ...mySip.confirmOTP, body })
    .then((res) => {
      resolve(res);
      if (res.status === 200) {
        resolve(res);
      }
    })
    .catch((err) => {
      console.log(err);
      reject(err);
    });
});

export const sendOTPMail = (body) => new Promise((resolve, reject) => {
  apiCall({ ...mySip.sendOTP, body })
    .then((res) => {
      resolve(res);
      if (res.status === 200) {
        resolve(res);
      }
    })
    .catch((err) => {
      console.log(err);
      reject(err);
    });
});

export const updatePassword = (id, body) => new Promise((resolve, reject) => {
  dashboard.updatePassword.entityId = id;
  apiCall({ ...dashboard.updatePassword, body })
    .then((res) => {
      resolve(res);
      if (res.status === 200) {
        resolve(res);
      }
    })
    .catch((err) => {
      console.log(err);
      reject(err);
    });
});
